module.exports = __webpack_public_path__ + "media/svg-new/settings-497e6128.svg";